<!-- @TODO : Remove this component when datatable.component will be full implemented -->
<div class="card">
    <div class="card-body">
                <h3 class="text-primary text-center">{{ tableTitle }}
                <span class="text-right ml-3" *ngIf="'lastActions' === type || 'lastUpdates' === type || 'lastWorkflows' === type">
                    <p-dropdown [options]="rowsPerPageOptions" (onChange)="loadData($event)"></p-dropdown>
                </span>
            </h3>
        <hr />
        <ng-container *ngIf="!table || table.length === 0">
            <!-- État vide illustré (opt-in via [emptyIllustration]) -->
            <div *ngIf="emptyIllustration; else simpleEmpty" class="table-empty text-center">
                <svg class="table-empty-illustration" width="92" height="92" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <!-- etincelles -->
                    <path d="M20 8 L21.1 10.9 L24 12 L21.1 13.1 L20 16 L18.9 13.1 L16 12 L18.9 10.9 Z" fill="#9fdbce"/>
                    <path d="M44 6 L44.8 8.2 L47 9 L44.8 9.8 L44 12 L43.2 9.8 L41 9 L43.2 8.2 Z" fill="#cdebe3"/>
                    <circle cx="37" cy="15" r="1.4" fill="#cdebe3"/>
                    <!-- bannette / inbox -->
                    <path d="M11 33 L18 19 H46 L53 33 V45 a4 4 0 0 1 -4 4 H15 a4 4 0 0 1 -4 -4 Z"
                          fill="#e2f3ef" stroke="#4eb8aa" stroke-width="2.2" stroke-linejoin="round"/>
                    <path d="M11 33 H23 L26 38 H38 L41 33 H53"
                          fill="none" stroke="#4eb8aa" stroke-width="2.2" stroke-linejoin="round" stroke-linecap="round"/>
                </svg>
                <div class="table-empty-title font-weight-bold">{{ 'general.no.result' | translate }}</div>
                <div *ngIf="emptyHint" class="table-empty-hint">{{ emptyHint }}</div>
            </div>
            <!-- État vide d'origine (par défaut, inchangé) -->
            <ng-template #simpleEmpty>
                <div class="text-center">
                    <span class="font-italic font-weight-bold">{{ 'general.no.result' | translate }}</span>
                </div>
            </ng-template>
        </ng-container>
        <div class="table-responsive">
            <table *ngIf="table && table.length" class="table table-hover">
                <thead>
                    <tr>
                        <ng-container *ngFor="let column of columns; let i = index">
                            <th scope="col" *ngIf="(i < 1 || !preview || preview.length === 0) && column !== 'draft' && column !== 'idOwnerGroup' && column !== 'idUser' && column !== 'archived'"> <!--&& column !== 'auths'-->
                                <span *ngIf="column === 'groups'"><i class="fas fa-users"></i></span> {{ 'table.' + column | translate }}
                            </th>
                        </ng-container>
                        <th *ngIf="!preview || preview.length === 0" scope="col">{{ 'table.actions' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let row of table">
                        <tr
                            [ngClass]="{ 'table-primary font-weight-bold': preview && preview[0] && preview[0].id == row[0] }">
                            <ng-container *ngFor="let value of row[1]; let i = index">
                                <td *ngIf="columns[i] !== 'idOwnerGroup' && columns[i] !== 'idUser' && columns[i] !== 'action' && columns[i] !== 'tags' && columns[i] !== 'groups' && (!preview || preview.length === 0) && columns[i] !== 'draft' && columns[i] !== 'archived'"><!--&& columns[i] !== 'auths'-->
                                    <span *ngIf="i === 0">{{ value }}</span>
                                    <div *ngIf="i > 0" [innerHtml]="safeHtml(value)"></div>
                                </td>
                                <td *ngIf="columns[i] !== 'idOwnerGroup' && columns[i] !== 'idUser' && columns[i] !== 'action' && columns[i] === 'tags' && columns[i] !== 'groups' && (!preview || preview.length === 0) && columns[i] !== 'draft' && columns[i] !== 'archived'"><!--&& columns[i] !== 'auths'-->
                                    <span class="badge badge-pill badge-primary mr-1" *ngFor="let tag of value">{{tag}}</span>
                                </td>
                                <td *ngIf="columns[i] !== 'idOwnerGroup' && columns[i] !== 'idUser' && columns[i] !== 'action' && columns[i] !== 'tags' && columns[i] === 'groups' && (!preview || preview.length === 0) && columns[i] !== 'draft' && columns[i] !== 'archived'"><!--&& columns[i] !== 'auths'-->
                                    <span class="badge badge-pill badge-primary mr-1" *ngFor="let group of value">{{group}}</span>
                                </td>
                                <td *ngIf="columns[i] !== 'idOwnerGroup' && columns[i] !== 'idUser' && columns[i] !== 'action' && preview && preview.length > 0 && i === 0 && columns[i] !== 'archived'"><!--&& columns[i] !== 'auths'-->
                                    <div (click)="this.select.emit(row[0])" class="pointer" [innerHtml]="safeHtml(value)"></div>
                                </td>
                                <td *ngIf="columns[i] === 'action'">
                                    <div>{{ "table.actionType." + value | translate }}</div>
                                </td>
                            </ng-container>
                            <td *ngIf="controlActionShow(row); else elseBlock">
                                <app-action-buttons [groupRight]="row[2] ? row[2]: []" [actions]="actions" (action)="onActionClick($event, row[0])" [hideViewIfEditAllowed]="hideViewButtonIfEditAllowed" buttonOutlined="true"></app-action-buttons>
                            </td>
                            <ng-template #elseBlock>
                                <td></td>
                            </ng-template>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</div>